const socials = [
  {
    name: "TikTok",
    handle: "@superpicinasflorentin",
    url: "https://www.tiktok.com/@superpicinasflorentin?lang=es-419",
    icon: "ri-tiktok-line",
    desc: "Síguenos en TikTok y descubre vídeos de nuestros proyectos, consejos de mantenimiento y trabajos en tiempo real.",
    color: "from-[#010101] via-[#1a0a12] to-[#010101]",
    accent: "text-white",
    badge: "bg-[#EE1D52]/80",
  },
  {
    name: "Facebook",
    handle: "Superpiscinas Florin",
    url: "https://www.facebook.com/dobre.florentin.7",
    icon: "ri-facebook-circle-fill",
    desc: "Únete a nuestra comunidad en Facebook. Comparte tu experiencia, consulta novedades y contacta con nosotros directamente.",
    color: "from-blue-700 to-blue-500",
    accent: "text-white",
    badge: "bg-white/10",
  },
];

export default function SocialMedia() {
  return (
    <section className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-cyan-500 text-sm font-semibold uppercase tracking-widest">Redes Sociales</span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-800 mt-3 mb-4">
            Síguenos y mantente{" "}
            <span className="text-cyan-500">al día</span>
          </h2>
          <p className="text-slate-500 max-w-xl mx-auto text-base">
            Comparte con nosotros tu experiencia, descubre nuevos proyectos y mantente informado de todas nuestras novedades.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {socials.map((s) => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="nofollow noreferrer"
              className={`bg-gradient-to-br ${s.color} rounded-2xl p-8 flex flex-col gap-5 group hover:-translate-y-1 transition-all duration-300 cursor-pointer ${s.name === "TikTok" ? "ring-2 ring-[#69C9D0]/40" : ""}`}
            >
              {/* Icon + Name */}
              <div className="flex items-center gap-4">
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl ${s.badge} backdrop-blur-sm`}>
                  <i className={`${s.icon} text-white text-3xl`}></i>
                </div>
                <div>
                  <p className="text-white font-extrabold text-xl">{s.name}</p>
                  <p className="text-white/60 text-sm">{s.handle}</p>
                </div>
              </div>

              {/* Description */}
              <p className="text-white/80 text-sm leading-relaxed">{s.desc}</p>

              {/* CTA */}
              <div className="flex items-center gap-2 text-white font-semibold text-sm mt-auto group-hover:gap-3 transition-all">
                <span>Visitar perfil</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          ))}
        </div>

        {/* WhatsApp CTA */}
        <div className="mt-10 max-w-3xl mx-auto bg-green-500 rounded-2xl p-7 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
              <i className="ri-whatsapp-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-bold text-lg">WhatsApp directo</p>
              <p className="text-white/80 text-sm">Escríbenos ahora y te respondemos al momento</p>
            </div>
          </div>
          <a
            href="https://wa.me/34642885747?text=Hola%2C%20me%20gustar%C3%ADa%20solicitar%20un%20presupuesto%20para%20mi%20piscina."
            target="_blank"
            rel="nofollow noreferrer"
            className="bg-white text-green-600 font-bold px-7 py-3 rounded-full whitespace-nowrap hover:bg-green-50 transition-all cursor-pointer flex-shrink-0 text-sm"
          >
            Escríbenos por WhatsApp →
          </a>
        </div>
      </div>
    </section>
  );
}
